/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomForm } from './CustomForm';
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { toast } from 'react-toastify';
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";


const CustomerSchedulingCreate = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const formRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();
    let { schedulingId } = useParams();
    const decryptedId = AESDecrypt(schedulingId);
    const [view, setView] = useState(false);
    const { type } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const [showDetails, setShowDetails] = useState(true);

    const classes = customStyles();

    useEffect(() => {
        if (schedulingId !== undefined && decryptedId === 0) {
            history.push('/sales/setup/customer-product-scheduling');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Customer Product Scheduling', type, history, 'Sales')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }
    }, [schedulingId, type, roleManagement]);


    const loadTask = () => {
        if (schedulingId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "/v1/schedules/customer-schedules" });
        }
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (type === 'view') {
                setView(true);
            } else {
                setView(false);
            }
            formRef.current.onEdit(readDetails);
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {
            if (readError.error.statusCode) {
                toast.error('Customer Product Scheduling ID is invalid');
                history.push('/sales/setup/customer-product-scheduling');
            }
        }
    }, [readDetails, readError]);


    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'}
                closeLink={'/sales/setup/customer-product-scheduling'}
                img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Product Scheduling', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomForm
                        ref={formRef}
                        showDetails={type === 'create' ? false : showDetails}
                        loadMore={type === 'create' ? true : !showDetails}
                        view={view}
                        schedulingId={schedulingId === undefined ? schedulingId : decryptedId}
                        type={type}
                        roleManagement={roleManagement}
                        loadTask={() => loadTask()}
                        classes={classes}
                        dispatch={dispatch}
                        clsx={clsx}
                        history={history}
                        {...props}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default CustomerSchedulingCreate